// @flow

import * as React from "react";
import cx from "classnames";

import styles from "./RemoveField.scss";
import sharedStyles from "../shared/Shared.scss";

type AddFieldProps = {
  handleClick: () => void,
  text: () => React.Node
};

const RemoveField = ({ handleClick, text }: AddFieldProps) => (
  <button
    type="button"
    className={cx(sharedStyles.button, styles.removeButton)}
    onClick={handleClick}
  >
    {text()}
    &nbsp;
    <i className="icon-trash" />
  </button>
);

export default RemoveField;
